// src/pages/salas/salasStyles.js — estilos del módulo de salas de juntas.
// Usa los tokens del Desk (--c-*, --brand-*) para heredar tema claro/oscuro.
const SALAS_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
.sl-root {
    --sl-accent: var(--brand-700, #0a4aa8);
    --sl-accent-hover: var(--brand-800, #07357f);
    --sl-accent-light: #dbeafe;
    --sl-ring: rgba(10, 74, 168, .14);
    --sl-row: 44px;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
    min-height: 100vh; background: var(--c-bg); color: var(--c-text-1);
    display: flex; flex-direction: column;
}
.sl-root * { box-sizing: border-box; }

/* ── Barra superior ───────────────────────────────────────────────────── */
.sl-top {
    background: linear-gradient(160deg, var(--brand-900, #062a63) 0%, var(--brand-800, #07357f) 60%, var(--brand-700, #0a4aa8) 100%);
    color: #fff; position: sticky; top: 0; z-index: 20;
    box-shadow: 0 2px 10px rgba(8,29,73,.18);
}
.sl-top-in { max-width: 1180px; margin: 0 auto; padding: 10px 16px; display: flex; align-items: center; gap: 14px; }
.sl-logo { height: 26px; width: auto; filter: drop-shadow(0 1px 3px rgba(0,0,0,.2)); }
.sl-brand { display: flex; flex-direction: column; line-height: 1.1; }
.sl-brand b { font-size: 14.5px; font-weight: 700; letter-spacing: -.01em; }
.sl-brand span { font-size: 10.5px; opacity: .75; text-transform: uppercase; letter-spacing: 1.4px; font-weight: 600; }
.sl-nav { margin-left: auto; display: flex; align-items: center; gap: 4px; }
.sl-nav a, .sl-nav button {
    color: rgba(255,255,255,.85); text-decoration: none; font-size: 13px; font-weight: 600;
    padding: 7px 11px; border-radius: 8px; border: none; background: transparent; cursor: pointer; font-family: inherit;
    display: inline-flex; align-items: center; gap: 6px; transition: background .15s, color .15s;
}
.sl-nav a:hover, .sl-nav button:hover { background: rgba(255,255,255,.12); color: #fff; }
.sl-nav a.active { background: rgba(255,255,255,.18); color: #fff; }
.sl-user { font-size: 12px; opacity: .8; padding: 0 6px; max-width: 180px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
@media (max-width: 640px) {
    .sl-user { display: none; }
    .sl-nav a span.lbl, .sl-nav button span.lbl { display: none; }
    .sl-nav a, .sl-nav button { padding: 8px; }
}

.sl-main { max-width: 1180px; width: 100%; margin: 0 auto; padding: 18px 16px 60px; flex: 1; }

/* ── Controles ───────────────────────────────────────────────────────── */
.sl-toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-bottom: 14px; }
.sl-datebox { display: flex; align-items: center; gap: 4px; }
.sl-date-label { font-size: 17px; font-weight: 700; letter-spacing: -.01em; text-transform: capitalize; min-width: 180px; }
.sl-date-sub { font-size: 12px; color: var(--c-text-3); }
.sl-btn {
    display: inline-flex; align-items: center; justify-content: center; gap: 6px;
    border: 1px solid transparent; border-radius: 9px; padding: 8px 14px;
    font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; transition: all .15s; line-height: 1.2;
}
.sl-btn:disabled { opacity: .5; cursor: not-allowed; }
.sl-btn.sm { padding: 6px 10px; font-size: 12.5px; }
.sl-btn.icon { padding: 7px; width: 34px; height: 34px; }
.sl-btn-primary { background: var(--sl-accent); color: #fff; border-color: var(--sl-accent); box-shadow: 0 1px 3px rgba(10,74,168,.3); }
.sl-btn-primary:hover:not(:disabled) { background: var(--sl-accent-hover); }
.sl-btn-ghost { background: var(--c-card); color: var(--c-text-2); border-color: var(--c-border); }
.sl-btn-ghost:hover:not(:disabled) { background: var(--c-msg-bg); }
.sl-btn-danger { background: #fee2e2; color: #b91c1c; border-color: #fecaca; }
.sl-btn-danger:hover:not(:disabled) { background: #fecaca; }
.sl-input, .sl-select, .sl-textarea {
    width: 100%; padding: 9px 12px; font-size: 14px; font-family: inherit;
    border: 1px solid var(--c-border); border-radius: 9px;
    background: var(--c-input-bg); color: var(--c-text-1); outline: none;
    transition: border-color .15s, box-shadow .15s;
}
.sl-input:focus, .sl-select:focus, .sl-textarea:focus { border-color: var(--sl-accent); box-shadow: 0 0 0 3px var(--sl-ring); }
.sl-input.auto { width: auto; }
.sl-textarea { min-height: 70px; resize: vertical; }
.sl-field { margin-bottom: 13px; }
.sl-label { display: block; font-size: 12px; font-weight: 600; color: var(--c-text-2); margin-bottom: 5px; }
.sl-row2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.sl-hint { font-size: 12px; color: var(--c-text-4); margin-top: 4px; }

/* Tabs de sala (móvil) */
.sl-tabs { display: none; gap: 6px; margin-bottom: 12px; overflow-x: auto; padding-bottom: 2px; }
.sl-tab {
    flex: 1; min-width: 90px; border: 1px solid var(--c-border); background: var(--c-card); color: var(--c-text-2);
    border-radius: 999px; padding: 8px 12px; font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; white-space: nowrap;
}
.sl-tab.active { background: var(--tab-color, var(--sl-accent)); color: #fff; border-color: transparent; }

/* ── Rejilla del día ─────────────────────────────────────────────────── */
.sl-grid-wrap { background: var(--c-card); border: 1px solid var(--c-border); border-radius: 14px; overflow: hidden; box-shadow: 0 1px 2px rgba(15,23,42,.04); }
.sl-grid { display: grid; grid-template-columns: 56px repeat(var(--cols, 3), minmax(0, 1fr)); }
.sl-grid-head { position: sticky; top: 46px; z-index: 5; background: var(--c-card); border-bottom: 1px solid var(--c-border); }
.sl-grid-head .sl-cell { padding: 10px 8px; font-size: 13px; font-weight: 700; text-align: center; border-left: 1px solid var(--c-border); }
.sl-grid-head .sl-cell small { display: block; font-size: 11px; color: var(--c-text-4); font-weight: 500; margin-top: 1px; }
.sl-room-dot { display: inline-block; width: 8px; height: 8px; border-radius: 50%; margin-right: 6px; vertical-align: middle; }
.sl-times { position: relative; }
.sl-time { height: var(--sl-row); font-size: 11px; color: var(--c-text-4); text-align: right; padding-right: 8px; font-variant-numeric: tabular-nums; transform: translateY(-7px); }
.sl-col { position: relative; border-left: 1px solid var(--c-border); }
.sl-slot { height: var(--sl-row); border-top: 1px dashed var(--c-border); cursor: pointer; transition: background .1s; }
.sl-slot:first-child { border-top: none; }
.sl-slot.hour { border-top-style: solid; }
.sl-slot:hover { background: var(--sl-ring); }
.sl-slot.past { cursor: default; background: repeating-linear-gradient(135deg, transparent 0 6px, rgba(15,23,42,.035) 6px 7px); }
.sl-slot.past:hover { background: repeating-linear-gradient(135deg, transparent 0 6px, rgba(15,23,42,.035) 6px 7px); }
.sl-slot.closed { cursor: default; background: var(--c-msg-bg); }
.sl-slot.busy { cursor: not-allowed; }
.sl-slot.busy:hover { background: transparent; }
.sl-evt {
    position: absolute; left: 4px; right: 4px; border-radius: 8px; padding: 5px 8px;
    background: var(--evt-bg, var(--sl-accent-light)); border-left: 4px solid var(--evt-color, var(--sl-accent));
    color: var(--c-text-1); font-size: 12px; line-height: 1.25; overflow: hidden; cursor: pointer;
    box-shadow: 0 1px 2px rgba(15,23,42,.08); transition: transform .1s, box-shadow .1s;
}
.sl-evt:hover { transform: translateY(-1px); box-shadow: 0 4px 10px rgba(15,23,42,.12); z-index: 3; }
.sl-evt.mine { outline: 2px solid var(--evt-color, var(--sl-accent)); outline-offset: -2px; }
.sl-evt b { display: block; font-weight: 700; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sl-evt span { display: block; color: var(--c-text-3); font-size: 11px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sl-now { position: absolute; left: 0; right: 0; height: 2px; background: #dc2626; z-index: 4; pointer-events: none; }
.sl-now::before { content: ''; position: absolute; left: -4px; top: -3px; width: 8px; height: 8px; border-radius: 50%; background: #dc2626; }
@media (max-width: 720px) {
    .sl-tabs { display: flex; }
    .sl-grid { grid-template-columns: 50px 1fr; }
    .sl-col.hidden-m, .sl-grid-head .sl-cell.hidden-m { display: none; }
    .sl-root { --sl-row: 48px; }
    .sl-date-label { font-size: 15px; min-width: 0; }
}

/* ── Listas / tarjetas ───────────────────────────────────────────────── */
.sl-section { margin-top: 22px; }
.sl-section h3 { font-size: 15px; font-weight: 700; margin: 0 0 10px; }
.sl-card { background: var(--c-card); border: 1px solid var(--c-border); border-radius: 12px; padding: 14px 16px; box-shadow: 0 1px 2px rgba(15,23,42,.04); }
.sl-list { display: flex; flex-direction: column; gap: 8px; }
.sl-item { display: flex; align-items: center; gap: 12px; padding: 10px 14px; background: var(--c-card); border: 1px solid var(--c-border); border-radius: 10px; }
.sl-item-date { display: flex; flex-direction: column; align-items: center; min-width: 50px; background: var(--c-msg-bg); border-radius: 8px; padding: 5px 6px; }
.sl-item-date b { font-size: 18px; line-height: 1; }
.sl-item-date small { font-size: 10px; text-transform: uppercase; letter-spacing: .5px; color: var(--c-text-3); font-weight: 700; }
.sl-item-body { flex: 1; min-width: 0; }
.sl-item-body b { display: block; font-size: 13.5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sl-item-body span { font-size: 12px; color: var(--c-text-3); }
.sl-chip { display: inline-flex; align-items: center; gap: 6px; border-radius: 999px; padding: 3px 10px; font-size: 12px; font-weight: 600; background: var(--c-msg-bg); color: var(--c-text-2); border: 1px solid var(--c-border); }
.sl-chip .x { cursor: pointer; opacity: .6; } .sl-chip .x:hover { opacity: 1; }
.sl-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.sl-empty { text-align: center; color: var(--c-text-4); font-size: 13px; padding: 18px; }
.sl-muted { color: var(--c-text-3); font-size: 13px; }

/* ── Modal ───────────────────────────────────────────────────────────── */
.sl-overlay { position: fixed; inset: 0; background: rgba(8,29,73,.45); backdrop-filter: blur(2px); z-index: 50; display: flex; align-items: flex-end; justify-content: center; padding: 0; }
.sl-modal { background: var(--c-card); color: var(--c-text-1); width: 100%; max-width: 520px; border-radius: 18px 18px 0 0; padding: 20px 20px 24px; max-height: 92vh; overflow-y: auto; animation: sl-up .25s ease-out; }
@media (min-width: 640px) { .sl-overlay { align-items: center; padding: 20px; } .sl-modal { border-radius: 16px; } }
@keyframes sl-up { from { transform: translateY(20px); opacity: 0; } to { transform: none; opacity: 1; } }
.sl-modal-head { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
.sl-modal-head h2 { font-size: 17px; font-weight: 700; margin: 0; flex: 1; }
.sl-modal-foot { display: flex; gap: 8px; justify-content: flex-end; flex-wrap: wrap; margin-top: 16px; }
.sl-detail { display: grid; grid-template-columns: 90px 1fr; gap: 6px 12px; font-size: 13.5px; }
.sl-detail dt { color: var(--c-text-4); font-weight: 500; }
.sl-detail dd { margin: 0; font-weight: 500; }
.sl-alert { border-radius: 10px; padding: 10px 14px; font-size: 13px; line-height: 1.5; margin-bottom: 12px; }
.sl-alert.warn { background: #fef3c7; color: #92400e; border: 1px solid #fde68a; }
.sl-alert.err { background: #fee2e2; color: #991b1b; border: 1px solid #fecaca; }
.sl-alert.info { background: var(--sl-accent-light); color: var(--sl-accent); }

/* Autocomplete */
.sl-ac { position: relative; }
.sl-ac-list { position: absolute; left: 0; right: 0; top: 100%; background: var(--c-card); border: 1px solid var(--c-border); border-radius: 10px; margin-top: 4px; z-index: 10; box-shadow: 0 8px 24px rgba(15,23,42,.14); max-height: 220px; overflow-y: auto; }
.sl-ac-item { padding: 8px 12px; cursor: pointer; font-size: 13px; }
.sl-ac-item:hover { background: var(--c-msg-bg); }
.sl-ac-item small { display: block; color: var(--c-text-4); font-size: 11.5px; }

/* ── Sin acceso / login ──────────────────────────────────────────────── */
.sl-center { min-height: 60vh; display: flex; align-items: center; justify-content: center; padding: 24px; }
.sl-denied { max-width: 440px; text-align: center; }
.sl-denied h2 { font-size: 20px; margin: 10px 0 6px; }
.sl-denied p { color: var(--c-text-3); font-size: 14px; line-height: 1.55; }
.sl-denied .who { background: var(--c-msg-bg); border-radius: 10px; padding: 10px 14px; font-size: 13px; text-align: left; margin: 14px 0; }
.sl-denied .who div { display: flex; justify-content: space-between; gap: 10px; padding: 2px 0; }
.sl-denied .who span { color: var(--c-text-4); }

/* ── QR ──────────────────────────────────────────────────────────────── */
.sl-qr-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 16px; }
.sl-qr-card { background: #fff; color: #0b1a3a; border: 1px solid #e5e7eb; border-radius: 16px; padding: 22px 18px; text-align: center; }
.sl-qr-card.big { grid-column: 1 / -1; padding: 30px 20px; }
.sl-qr-card h2 { font-size: 20px; margin: 12px 0 4px; font-weight: 800; letter-spacing: -.01em; }
.sl-qr-card h3 { font-size: 16px; margin: 10px 0 2px; font-weight: 700; }
.sl-qr-card p { font-size: 12.5px; color: #4b5563; margin: 0; line-height: 1.5; }
.sl-qr-card .url { font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 12px; color: #0a4aa8; margin-top: 6px; word-break: break-all; }
.sl-qr-card .logo { height: 22px; margin-bottom: 8px; }
@media print {
    .sl-top, .sl-toolbar, .sl-noprint { display: none !important; }
    .sl-root { background: #fff; }
    .sl-main { padding: 0; max-width: none; }
    .sl-qr-card { break-inside: avoid; border-color: #d1d5db; }
}

/* ── Admin ───────────────────────────────────────────────────────────── */
.sl-admin-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
@media (max-width: 860px) { .sl-admin-grid { grid-template-columns: 1fr; } }
.sl-card h3 { font-size: 14.5px; font-weight: 700; margin: 0 0 4px; }
.sl-card .desc { font-size: 12.5px; color: var(--c-text-3); margin: 0 0 12px; line-height: 1.5; }
.sl-room-row { display: grid; grid-template-columns: 1fr 70px 1fr 40px 36px; gap: 8px; align-items: center; margin-bottom: 8px; }
@media (max-width: 560px) { .sl-room-row { grid-template-columns: 1fr 60px 40px 36px; } .sl-room-row .loc { display: none; } }
.sl-days { display: flex; gap: 6px; flex-wrap: wrap; }
.sl-day { border: 1px solid var(--c-border); border-radius: 8px; padding: 6px 10px; font-size: 12.5px; font-weight: 600; cursor: pointer; background: var(--c-card); color: var(--c-text-2); font-family: inherit; }
.sl-day.on { background: var(--sl-accent); color: #fff; border-color: transparent; }
.sl-sticky-save { position: sticky; bottom: 12px; display: flex; justify-content: flex-end; margin-top: 16px; }
`;

export default SALAS_CSS;
